import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { TemplateSalvamentoModel } from '../model/template/template-salvamento-model';
import { TemplateBusca } from '../model/template/template-busca.model';
import { TemplatesChatPagina } from '../model/template/templates-chat-pagina.model';
import { EnvioMensagemTemplate } from '../model/chat/mensagens/envio-mensagem-template.model';
import { PageModel } from '../model/page-mode.model';
import { TemplateEnvioRedirecionamento } from '../model/template/template-envio-redirecionamento.model';
import { IdNome } from '../model/id-nome.model';

@Injectable({
  providedIn: 'root',
})
export class TemplateMensagemService {

  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/template`;
  urlBaseServiceEnvio = `${environment.urlBase}/mensagem-template`;

  buscarResumoTemplatesChat(perfilId: number, page: number, size: number, busca: string): Observable<TemplatesChatPagina> {
    let params = new HttpParams().set('perfilId', perfilId).set('page', page).set('size', size);
    if (busca) params = params.set('busca', busca);
    return this.http.get<TemplatesChatPagina>(`${this.urlBase}/chat`, { params, headers: { 'no-loading': 'true' } });
  }

  buscarTemplatesFiltrado(filtro: any, page: number, limit: number): Observable<PageModel> {
    return this.http.post<PageModel>(`${this.urlBase}/filtrado`, filtro, {
      params: {
        page: page,
        limit: limit
      }
    });
  }

  /** @deprecated Busca todos os templates aprovados com componentes de uma vez. Prefira busca resumida/paginada + detalhe por id. Posteriormente vamos remover o metodo, esperar so redesign completo, favor n usar */
  buscarTemplatesAprovados(): Observable<TemplateSalvamentoModel[]> {
    return this.http.get<any[]>(`${this.urlBase}/aprovados`);
  }

  buscarSelectTemplatesLembrete(): Observable<IdNome[]> {
    return this.http.get<IdNome[]>(`${this.urlBase}/lembrete/select`, { headers: { 'no-loading': 'true' } });
  }

  buscarTemplateLembrete(templateId: number): Observable<TemplateSalvamentoModel> {
    return this.http.get<TemplateSalvamentoModel>(`${this.urlBase}/lembrete/detalhe/${templateId}`, { headers: { 'no-loading': 'true' } });
  }

  /** @deprecated Busca todos os templates aprovados com componentes de uma vez. Prefira busca resumida/paginada + detalhe por id. Posteriormente vamos remover o metodo, esperar so redesign completo, favor n usar */
  buscarTemplatesSmsAprovados(): Observable<TemplateSalvamentoModel[]> {
    return this.http.get<any[]>(`${this.urlBase}/sms/aprovados`).pipe(
      map(res => (res ?? []).map(raw => TemplateSalvamentoModel.fromSmsBackend(raw)))
    );
  }

/** @deprecated Busca todos os templates aprovados com componentes de uma vez. Prefira busca resumida/paginada + detalhe por id. Posteriormente vamos remover o metodo, esperar so redesign completo, favor n usar */
  buscarTemplatesAprovadosDisparo(tipo: 'WHATSAPP' | 'SMS'): Observable<TemplateSalvamentoModel[]> {
    return this.http.get<any[]>(`${this.urlBase}/disparo/aprovados/${tipo}`).pipe(
      map(res => tipo === 'SMS'
        ? (res ?? []).map(raw => TemplateSalvamentoModel.fromSmsBackend(raw))
        : (res ?? []))
    );
  }

  /** @deprecated Busca todos os templates aprovados com componentes de uma vez. Prefira busca resumida/paginada + detalhe por id. Posteriormente vamos remover o metodo, esperar so redesign completo, favor n usar */
  buscarTemplatesParaCanal(): Observable<TemplateSalvamentoModel[]> {
    return forkJoin({
      whatsapp: this.buscarTemplatesAprovados(),
      sms: this.buscarTemplatesSmsAprovados()
    }).pipe(map(({ whatsapp, sms }) => [
      ...(whatsapp ?? []),
      ...(sms ?? []).map(template => Object.assign(new TemplateSalvamentoModel(), template, {
        name: `SMS - ${template.name ?? ''}`
      }))
    ]));
  }

  buscarArquivoHeaderTemplate(templateId: number): Observable<Blob> {
    return this.http.get(
      `${this.urlBase}/buscar-arquivo-template/${templateId}`,
      {
        responseType: 'blob',
      }
    );
  }

  salvarTemplate(template: TemplateSalvamentoModel): Observable<boolean> {
    return this.http.post<boolean>(`${this.urlBase}`, template);
  }

  enviarMensagemTemplate(envioMensagem: EnvioMensagemTemplate,): Observable<EnvioMensagemTemplate> {
    return this.http.post<any>(`${this.urlBaseServiceEnvio}/enviar`,envioMensagem,);
  }

  resolverRedirecionamento(objEnvio: TemplateEnvioRedirecionamento){
    return this.http.post<TemplateEnvioRedirecionamento>(`${this.urlBaseServiceEnvio}/resolver-redirecionamento`, objEnvio);
  }

  inativarTemplate(templateId: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.urlBase}/inativar/${templateId}`);
  }

  /** @deprecated Busca todos os templates aprovados com componentes de uma vez. Prefira busca resumida/paginada + detalhe por id. Posteriormente vamos remover o metodo, esperar so redesign completo, favor n usar */
  buscarTemplatesSetor(setorId: number): Observable<TemplateSalvamentoModel[]> {
    return this.http.get<any[]>(`${this.urlBase}/por-setor/${setorId}`);
  }

  buscarTemplatePorId(templateId: number): Observable<TemplateBusca> {
    return this.http.get<TemplateBusca>(`${this.urlBase}/${templateId}`);
  }
}
